export default async (kernel) => {
    await kernel.clear()
}
